import { toast } from 'sonner';

/**
 * Handle an axios error from an endpoint protected by plan limits.
 * Returns true if the error was a 402 plan-limit error and a toast was shown.
 *
 * Usage:
 *   } catch (e) {
 *     if (!handlePlanLimitError(e, navigate)) toast.error('...');
 *   }
 */
export const handlePlanLimitError = (error, navigate) => {
  const status = error?.response?.status;
  const detail = error?.response?.data?.detail;
  if (status === 402 && detail?.error === 'plan_limit_reached') {
    toast.error(detail.message || 'Limite atteinte', {
      description: `Plan ${detail.plan_name} — passe à un plan supérieur pour continuer.`,
      duration: 6000,
      action: navigate
        ? {
            label: 'Voir les plans',
            onClick: () => navigate(detail.upgrade_url || '/dashboard/abonnement'),
          }
        : undefined,
    });
    return true;
  }
  return false;
};

/**
 * Message lisible pour un toast : FastAPI renvoie `detail` en texte, en objet
 * (limite de plan) ou en liste (erreur de validation 422).
 */
export const apiErrorMessage = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (typeof detail?.message === 'string') return detail.message;
  if (Array.isArray(detail) && typeof detail[0]?.msg === 'string') return detail[0].msg;
  return fallback;
};
